const affiliation = {
    questions: [
        {
            id: 1,
            name: 'AffiliationMember',
            text: 'affiliation.are_member',
            selected: false
        },
        {
            id: 2,
            name: 'AffiliationBroker',
            text: 'affiliation.NFA_or_CFTC',
            selected: false
        },
        {
            id: 3,
            name: 'AffiliationForShellBank',
            text: 'affiliation.foreign_shell',
            selected: false
        },
        {
            id: 4,
            name: 'AffiliationShellBank',
            text: 'affiliation.owner_affiliated',
            selected: false
        },
        {
            id: 5,
            name: 'AffiliationShellBankService',
            text: 'affiliation.owner_offer',
            selected: false
        },
        {
            id: 6,
            name: 'AffiliationBankrupt',
            text: 'affiliation.bankruptcy_proceeding',
            selected: false
        },
        {
            id: 7,
            name: 'AffiliationLegal',
            text: 'affiliation.commodity_account',
            selected: false
        },
        {
            id: 8,
            name: 'AffiliationUnpaid',
            text: 'affiliation.commodity_firm',
            selected: false
        },
        {
            id: 9,
            name: 'AffiliationOtherFunds',
            text: 'affiliation.business_with_you',
            selected: false
        },
        {
            id: 10,
            name: 'AffiliationFFI',
            text: 'affiliation.financial_institution',
            selected: false
        },
        {
            id: 11,
            name: 'AffiliationPoliOfficial',
            text: 'affiliation.close_associate',
            selected: false
        }
    ],
    name: '',
    process: '',
    position: '',
    affPerson: '',
    companyName: '',
    organizations: '',
    memberPosition: '',
    memberAffPerson: '',
    memberCompanyName: ''
}

const SET_AFFILIATION_INFO = 'SET_AFFILIATION_INFO';
const SET_AFFILIATION_FIELD = 'SET_AFFILIATION_FIELD';

export const setQuestions = (questions) => ({
    type: SET_AFFILIATION_INFO,
    payload: questions,
});

export const setAffiliationField = (fieldName, value) => ({
    type: SET_AFFILIATION_FIELD,
    payload: {fieldName, value},
});

const affiliation_store = (state = affiliation, action) => {
    switch (action.type) {
        case SET_AFFILIATION_INFO:
            return {
                ...state,
                questions: action.payload,
            };
        case SET_AFFILIATION_FIELD:
            return {
                ...state,
                [action.payload.fieldName]: action.payload.value,
            };
        default:
            return state;
    }
};

export default affiliation_store;

